'use strict';

// NOTE: in WP we use the WP intern jQuery version
// globally "export" jquery for our plugins
// import jQuery from 'jquery';

// import version from './lib/version';
import './polyfill/object-fit';
import './_includes/foundation';

// ////////////////////////////////////////////////////////////
// track contact form 7 submissions
import './lib/analytics/cf7';

// ////////////////////////////////////////////////////////////
// init foundation
jQuery(($) => {
    const $menuButton = $('.menu-toggle .hamburger'),
        $offCanvasInner = $('.off-canvas-wrapper-inner'),
        $primaryNav = $('.primary-nav');

    $primaryNav.css('opacity', 1);

    $(document)
        .foundation()
        .on('opened.zf.offcanvas', () => {
            $menuButton.addClass('is-active');

            $offCanvasInner.addClass('js-off-canvas-opened');
            $offCanvasInner.removeClass('js-off-canvas-closed');
        })
        .on('closed.zf.offcanvas', () => {
            $menuButton.removeClass('is-active');

            $offCanvasInner.addClass('js-off-canvas-closed');
            $offCanvasInner.removeClass('js-off-canvas-opened');
        });

    // add a class to the html tag so animations and the like can react when the page is loaded
    document.documentElement.classList.add('page-loaded');

    // you can listen to breakpoint changes like so:
    // $(window).on('changed.zf.mediaquery', (event, current, old) => {
    //    console.log(`Breakpoint changed from "${old}" to "${current}"`);
    // });
});

// ////////////////////////////////////////////////////////////
// browser alerts
import oldBrowserAlert from './lib/alerts/old-browser';
oldBrowserAlert();

// ////////////////////////////////////////////////////////////
// scroll events
import scrollUp from '@spinnwerk/scroll-helper/scroll-up';
scrollUp();

// ////////////////////////////////////////////////////////////
// sliding header
import './lib/headroom';

// ////////////////////////////////////////////////////////////
// form helpers
import './lib/form/form';

// ////////////////////////////////////////////////////////////
// modal
// import './lib/modal';

// ////////////////////////////////////////////////////////////
// masonry
import './lib/layouts/showcases';

// ////////////////////////////////////////////////////////////
// masonry
import './lib/layouts/masonry';

// ////////////////////////////////////////////////////////////
// swiper
import './lib/layouts/swiper';

// ////////////////////////////////////////////////////////////
// map
import './lib/layouts/map';

// ////////////////////////////////////////////////////////////
// map
import './lib/layouts/previewer';



// WEBPACK FOOTER //
// ./resources/assets/js/app.js